import { postFetcher, fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'
import { WalletData } from '@/utils/types/wallet'
import { useMemo } from 'react'

export default function useWallet(options?: { cache?: boolean }): {
	data: WalletData
	isLoading: boolean
	mutate: any
} {
	const fetchWallet = options?.cache ? fetcher : postFetcher
	const hasPaymentsWallet = Wallet.provider.capabilities.includes('payments-wallet')
	const balanceAddress = Wallet.balanceAddress()
	const ordinalsAddress = Wallet.getTaprootAddress()

	const { data: balance, isLoading: isLoadingBalance } = useSwr(
		hasPaymentsWallet ? `${API_URL}/wallet/${balanceAddress}` : null,
		fetchWallet
	)
	const {
		data: inscriptions,
		isLoading: isLoadingInscriptions,
		mutate
	} = useSwr(hasPaymentsWallet ? `${API_URL}/wallet/${ordinalsAddress}` : null, fetchWallet)
	const singleWallet = useSwr(
		hasPaymentsWallet ? null : `${API_URL}/wallet/${balanceAddress}`,
		fetchWallet
	)

	const paymentsWalletData = useMemo<WalletData>(() => ({
			balance: balance?.balance,
			confirmed_balance: balance?.confirmed_balance,
			unconfirmed_balance: balance?.unconfirmed_balance,
			frozen_balance: balance?.frozen_balance,
			utxo_count: balance?.utxo_count,
			inscriptions: inscriptions?.inscriptions,
			brc20: inscriptions?.brc20,
			inscription_balance: inscriptions?.inscription_balance
		}), [
			balance?.balance,
			balance?.confirmed_balance,
			balance?.unconfirmed_balance,
			balance?.frozen_balance,
			balance?.utxo_count,
			inscriptions?.inscriptions,
			inscriptions?.brc20,
			inscriptions?.inscription_balance,
		])

	if (hasPaymentsWallet) {
		return { data: paymentsWalletData, isLoading: isLoadingBalance || isLoadingInscriptions, mutate }
	}

	return singleWallet
}
